import { batch } from 'react-redux';

// project imports
import mime from 'mime';
import gestopAPI from 'utils/gestopAPI';
import { dispatch } from 'store/index';
import { errorProcessor } from 'utils/processors';
import { crmClientActions } from './slice';
import capabilities from './capabilities';

export const ApiClientsGetCollection = async ({
    filters = [],
    orderBy = [],
    groupBy = [],
    page = 1,
    limit = 10,
    includeSafeDeleted = false,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(crmClientActions.startLoading());
    }

    await gestopAPI
        .post('crm/clients/list', { filters, orderBy, groupBy, page, limit, includeSafeDeleted }, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(crmClientActions.setList(response?.data?.list));
                    dispatch(crmClientActions.setCount(response?.data?.count));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(crmClientActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data?.list);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(crmClientActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(crmClientActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiClientsCountCollection = async ({
    filters = [],
    includeSafeDeleted = false,
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post('crm/clients/count', { filters, includeSafeDeleted }, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data?.count);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiClientsPostCollection = async ({
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(crmClientActions.startLoading());
    }

    await gestopAPI
        .post('crm/clients', data, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(crmClientActions.insertItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(crmClientActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(crmClientActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(crmClientActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiClientsDeleteCollection = async ({
    ids = [],
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(crmClientActions.startLoading());
    }

    await gestopAPI
        .post('crm/clients/safedelete', ids, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(crmClientActions.deleteItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(crmClientActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(crmClientActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(crmClientActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiClientsExportCollection = async ({
    exportType = 'allRows',
    format = 'pdf',
    columns = [],
    filters = [],
    orderBy = [],
    groupBy = [],
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    if (capabilities.app.includes('exporter')) {
        dispatch(crmClientActions.startExporting());
    }

    await gestopAPI
        .post('crm/clients/export', { exportType, format, columns, filters, orderBy, groupBy }, { ...config, responseType: 'blob' })
        .then((response) =>
            batch(() => {
                window.open(URL.createObjectURL(response?.data));

                if (capabilities.app.includes('exporter')) {
                    dispatch(crmClientActions.stopExporting());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('exporter')) {
                    dispatch(crmClientActions.stopExporting());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(crmClientActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiClientsPutItem = async ({
    id,
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(crmClientActions.startLoading());
    }

    await gestopAPI
        .put(`crm/clients/${id}`, data, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(crmClientActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(crmClientActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(crmClientActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(crmClientActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiClientsPatchItem = async ({
    id,
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(crmClientActions.startLoading());
    }

    await gestopAPI
        .patch(`crm/clients/${id}`, data, {
            ...config,
            headers: { ...config?.headers, 'Content-Type': 'application/merge-patch+json' } // Specific content type for PATCH requests
        })
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(crmClientActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(crmClientActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(crmClientActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(crmClientActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiClientsDeleteItem = async ({
    id,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(crmClientActions.startLoading());
    }

    await gestopAPI
        .post(`crm/clients/safedelete/${id}`, {}, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(crmClientActions.deleteItems(id));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(crmClientActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(crmClientActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(crmClientActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiClientsRestoreDeletedItem = async ({
    id,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(crmClientActions.startLoading());
    }

    await gestopAPI
        .post(`crm/clients/restoresafedeleted/${id}`, {}, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(crmClientActions.deleteItems(id));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(crmClientActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(crmClientActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(crmClientActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiClientsExportItem = async ({ id, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    if (capabilities.app.includes('exporter')) {
        dispatch(crmClientActions.startExporting());
    }

    await gestopAPI
        .get(`crm/clients/export/${id}`, { ...config, responseType: 'blob' })
        .then((response) =>
            batch(() => {
                window.open(URL.createObjectURL(response?.data));

                if (capabilities.app.includes('exporter')) {
                    dispatch(crmClientActions.stopExporting());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('exporter')) {
                    dispatch(crmClientActions.stopExporting());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(crmClientActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiClientsImportCollection = async ({ file, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    if (capabilities.app.includes('importer')) {
        dispatch(crmClientActions.startImporting());
    }

    const formData = new FormData();
    formData.append('file', file);

    await gestopAPI
        .post(`crm/clients/import`, formData, { ...config })
        .then((response) =>
            batch(() => {
                if (capabilities.app.includes('importer')) {
                    dispatch(crmClientActions.stopImporting());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('importer')) {
                    dispatch(crmClientActions.stopImporting());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(crmClientActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiClientsDownloadImportModelItem = async ({ successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    if (capabilities.app.includes('exporter')) {
        dispatch(crmClientActions.startExporting());
    }

    await gestopAPI
        .get(`crm/clients/getimporttpl`, { ...config, responseType: 'blob' })
        .then((response) =>
            batch(() => {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const href = URL.createObjectURL(blob);
                const link = document.createElement('a');
                const fileExt = mime.getExtension(response.headers['content-type']);

                const IMPORT_FILE_NAME = `ClientImportTpl${fileExt ? `.${fileExt}` : ''}`;

                link.href = href;
                link.setAttribute('download', IMPORT_FILE_NAME);
                link.style.display = 'none';
                link.click();

                URL.revokeObjectURL(href);

                if (capabilities.app.includes('exporter')) {
                    dispatch(crmClientActions.stopExporting());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('exporter')) {
                    dispatch(crmClientActions.stopExporting());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(crmClientActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiClientsGetItem = async ({ id, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    if (capabilities.app.includes('loader')) {
        dispatch(crmClientActions.startLoading());
    }

    await gestopAPI
        .get(`crm/clients/${id}`, config)
        .then((response) =>
            batch(() => {
                if (capabilities.app.includes('loader')) {
                    dispatch(crmClientActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(crmClientActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(crmClientActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiClientsFileManagerIndex = async ({ id, data = {}, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    await gestopAPI
        .post(`crm/clients/filemanager/${id}`, data, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiClientsFileManagerUpload = async ({ id, data = {}, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    await gestopAPI
        .post(`crm/clients/filemanager/upload/${id}`, data, {
            ...config,
            headers: { ...config?.headers, 'Content-Type': 'multipart/form-data' } // Specific content type for file requests
        })
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};
